<template>
  <section>
    <div class="user-main">
      <div class="utab clearfix flex">
        <ul class="clearlist clearfix fl">
          <li class="active">
            <a href="javascript:;">签约商品</a>
          </li>
        </ul>
         
           <input  type="text" placeholder="商品名称" class="layui-input" v-model="keyword" />
          
          <el-button round type="primary" size="small" class="exportantOrder" @click="search"> 查询</el-button>
         
      </div>
      <div class="user-cont layui-card">
        <el-table
          :span-method="arraySpanMethod"
          border
          :data="contractGoods.data"
          style="width: 98%">
          <el-table-column prop="title" label="商品名字"></el-table-column>
          <el-table-column prop="sn" label="商品编码"></el-table-column>
          <el-table-column label="商品信息" width="350" class-name="tablegoodsinfo">
            <template slot-scope="scope">
              <div class="hebin">
                <div class="clearfix cpinfo flex">
                  <div class="img">
                    <a :href="'/product/'+ scope.row.productid+'.html?specification='+scope.row.specification" target="_blank">
                      <img :src="scope.row.indexpic" />
                    </a>
                  </div>
                  <div class="cont flex">
                    <div class style="width:240px">
                      <div class="name ellipsis-2">{{scope.row.title}}</div>
                      <div class="info color-primary">{{scope.row.specname}}</div>
                    </div>
                    <div class="color-primary" style="width:50px;text-align:right" >{{scope.row.unit}}</div>
                    <div class="color-primary"  style="width:60px;text-align:right" >{{scope.row.price}}</div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="60"></el-table-column>
          <el-table-column label="单价" width="80"></el-table-column>
          <el-table-column  label="数量" width="140">
            <template slot-scope="scope">
				
              <el-input-number class="jishuqi" v-model="scope.row.num"  :min="1" :max="1000" size='small'></el-input-number>
				 
            </template>
          </el-table-column>
		  <el-table-column  label="操作" width="120" >
            <template slot-scope="scope">
             
                 <el-button type="primary" round size='small' @click="addCart(scope.row)">加入购物车</el-button>
            
            </template>
          </el-table-column>
        </el-table>
		
        <div class="layui-card-body">
          <el-pagination
            class="fenye"
            background
            layout="prev, pager, next"
            :page-size="~~contractGoods.per_page"
            @current-change="currentPagegoods"
            :total="contractGoods.total"
          ></el-pagination>
        </div>
      </div>
	  
    </div>
	<!-- <div>
		<el-input-number  v-model="n"  :min="1" :max="1000" size='small' label="描述文字"></el-input-number>
	</div> -->
  </section>
</template>

<script>
import eventBus from "../../static/eventBus.js";
export default {
  name: "qianyue",
  data() {
    return {
		
      contractGoods: {},
       carnum:"",
       keyword:"",page:1,
    };
  },
    watch:{
    carnum(){
      eventBus.$emit('changecarnum',this.carnum)
    },
  },
  props: {},
  methods: {
	  changeNum:function(n){
		console.log(n)  
	  },
    currentPagegoods(e) {
      console.log(e)
      this.page = e;
      this.getOrderList();
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        return [1, 3];
      } else if (columnIndex === 3) {
        return [0, 0];
      } else if (columnIndex === 4) {
        return [0, 0];
      }
    },
     search() {
      this.getOrderList();
    },
        // 加入购物车
  async addCart(item){
      console.log(item)
        let res = await this.$fetch("Cart/edit", {
        body: {
          productid: item.productid,
          specification: item.specification,
          num:item.num
        }
      });
      if(res){
        console.log(this.carnum)
         this.carnum=res
         console.log(this.carnum)
        this.$message.success("操作成功");
      }
    },
    async getOrderList() {
      let contractGoods = await this.$fetch("shop/productsign",{body:{page:this.page,keyword:this.keyword}});
      this.contractGoods = contractGoods;
   
   //    for(let i=0;i<contractGoods.data.length;i++){
   //      if(contractGoods.data[i].num){
			
   //      }else{
   //        contractGoods.data[i]['num']=1
   //      }
   //    }
         console.log("签约商品列表", contractGoods.data);
    },
    keyupSubmit() {
      document.onkeydown = e => {
        let _key = window.event.keyCode;
        if (_key == 13) {
          this.search();
        }
      };
    },
  },
  created() {
    this.keyupSubmit();
  },
  async mounted() {
    this.getOrderList();
  }
};
</script>

<style lang='scss' scoped>
.jishuqi{
  margin-right: 12px;
  width: 100px;
}
.cpgroup .bd .item .tit {
  margin-top: 0;
  font-size: 16px;
}
.cpgroup .bd .item .price {
  margin-top: 0;
}
.cpgroup .bd .item {
  padding-bottom: 0;
}
.img {
  margin-bottom: 10px;
  a {
    display: inline-block;
    width: 100%;
    height: 100%;
    img {
      width: 80px;
      height: 80px;
    }
  }
}
.utab{
  justify-content: flex-start;
  input{
    width: 200px;
    margin-right: 12px;font-weight: normal;font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/qianyue.vue